export const SET_FACILITY_DETAILS = "SET_FACILITY_DETAILS";
export const SET_LOCATION_DETAILS = "SET_LOCATION_DETAILS";

export const setFacilityDetailsForLocation = (facilityDetails: any) => {
    return {
        type: SET_FACILITY_DETAILS,
        payload: facilityDetails
    }
};

export const setLocationDetailsForTestOrder = (locationDetails: any) => {
    return {
        type: SET_LOCATION_DETAILS,
        payload: locationDetails
    }
}